import React from "react";

import { TextState, Preview } from "@creatomate/preview";
import { NumberField } from "@culturehq/components";

import { CreatomatePropertyValue } from "chq";
import { Trans } from "app/utils";

interface LineHeightProps {
  activeElement: TextState;
  disabled?: boolean;
  preview: Preview;
  onSubtitlePropChange?: (propertyName: string, value: CreatomatePropertyValue) => Promise<void>;
}

const MAX_LINE_HEIGHT = 400;

const LineHeight: React.FC<LineHeightProps> = ({
  activeElement,
  disabled,
  preview,
  onSubtitlePropChange
}) => {
  const handleLineHeightChange = async (value: string) => {
    let lineHeight = +value || 115;
    if (lineHeight > MAX_LINE_HEIGHT) lineHeight = MAX_LINE_HEIGHT;
    if (onSubtitlePropChange) {
      await onSubtitlePropChange("line_height", lineHeight);
    } else {
      await preview.applyModifications({
        [`${activeElement.source.id}.line_height`]: lineHeight
      });
    }
  };

  return (
    <NumberField
      className="chq-ffd-border"
      disabled={disabled}
      name="line-height"
      min={1}
      value={activeElement?.source?.line_height?.replace("%", "") || "115"}
      onChange={handleLineHeightChange}
    >
      <Trans>Line Height (%)</Trans>
    </NumberField>
  );
};

export default LineHeight;
